import React, { FC } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import Close from "../../../../assets/Close.svg";
import CheckMark from "../../../../assets/CurrencyCheckMark.svg";
import { CURRENCY_FLAGS } from "static/currencies";
import { timer } from "helpers/functions";

interface TotalAmountBottomsheetProps {
  handleClose: () => void;
  data: any[];
  selectedCode: string;
  onSelect: (code: string) => void;
  getTotalBalance?: (code: string) => number;
  getTotalPerformance?: (code: string) => { amount: string | number };
}

const TotalAmountBottomsheet: FC<TotalAmountBottomsheetProps> = ({
  handleClose,
  data,
  selectedCode,
  onSelect,
  getTotalBalance,
  getTotalPerformance,
}) => {
  const { t } = useTranslation("app");
  const isPerformance = typeof getTotalPerformance === "function";

  return (
    <div
      className="total-amount-bottomsheet-overlay"
      onClick={(e) => {
        e.stopPropagation();
        handleClose();
      }}
    >
      <div
        className="total-amount-bottomsheet"
        onClick={(e) => {
          e.stopPropagation();
          timer(0.1).then(() => {
            handleClose();
          });
        }}
      >
        <div className="total-amount-bottomsheet__header">
          <p>{t("displayBalanceIn")}</p>
          <button onClick={handleClose} aria-label={t("close")}>
            <img src={Close} alt={t("close")} />
          </button>
        </div>

        <div className="total-amount-bottomsheet__rows">
          {data.map((item) => (
            <div
              key={item.code}
              className={`total-amount-bottomsheet__rows__row ${
                item.code === selectedCode ? "selected" : ""
              }`}
              onClick={() => onSelect(item.code)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  onSelect(item.code);
                }
              }}
            >
              <div className="total-amount-bottomsheet__rows__row__left">
                <div className="cur-flag-wrapper">
                  <img
                    className="checked"
                    src={CURRENCY_FLAGS[item.code]}
                    alt={`${item.code} flag`}
                  />
                  {item.code === selectedCode && (
                    <img
                      className="cur-flag-checkmark"
                      src={CheckMark}
                      alt={t("selected")}
                    />
                  )}
                </div>
                <div>
                  <p>{item.code}</p>
                  {/* <span>{item.name}</span> */}
                </div>
              </div>
              <p>
                {/* <p>{t("total")}</p> */}
                {isPerformance
                  ? getTotalPerformance(item.code).amount
                  : +getTotalBalance!(item.code).toFixed(4)}
                {item.symbol}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TotalAmountBottomsheet;


